var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"loading-animation"},[(_vm.loaderImage)?_c('Icon',{attrs:{"class-name":"text-flame logo","icon-name":"cloudenly_logo","size":_vm.size}}):_vm._e(),(_vm.loadingBar)?_c('div',{staticClass:"loading-bar",style:(_vm.loadingBarSize)}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }